import { useTranslation } from 'react-i18next'
import { HeroPage } from '@/components/HeroPage'
import { JobListings, WhyJoinUs } from '@/components/sections/JobListings'
import { CareersForm } from '@/components/sections/CareersForm'
import { ContactCTA } from '@/components/sections/ContactCTA'

export function Careers() {
  const { t } = useTranslation()

  return (
    <main>
      <HeroPage
        title={t('careers.hero.title')}
        subtitle={t('careers.hero.subtitle')}
        backgroundImage="/images/general/hero_lavora_con_noi.jpg"
        breadcrumb={[{ label: t('nav.careers') }]}
      />
      <JobListings />
      <WhyJoinUs />
      <CareersForm />
      <ContactCTA />
    </main>
  )
}
